import React, { Component } from 'react';

import {getModelTree} from "../../stateGetter";
import ItemManager from "./ItemManager";
import ResultManager from "./ResultManager";
import {connect} from "~/redux/connect";
import {presentModelManagerProps} from "~/statePresenter";
import { Box } from "~/native-ui";

class ModelManager extends Component {
	renderModelManagers = () => {
        let { modelId } = this.props;

		let managers = [
			<ItemManager modelId={modelId} key="ItemManager" />,
			<ResultManager modelId={modelId} key="ResultManager" />,
		];

		return managers;
	};
	
	render() {
		let { modelId, isDataModelLoaded } = this.props;

		if(!modelId) { return null; }

		return (
			<Box display="none">
				{isDataModelLoaded && this.renderModelManagers()}
			</Box>
		);
	}
}

const RXModelManager = connect(
	(state, {modelId}) => {
        // console.log('CHANGED B', state.lastAction.type, modelId);

		const model = getModelTree(state).getModel(modelId);
		if (!model) {
			return {
				modelId: null,
			}
		}

		return presentModelManagerProps(state, modelId)
	},
)(ModelManager);

export default RXModelManager;